import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import './TipsPage.css';

import tipsHero from '../../../../assets/tips-hero.png';

const TipsPage: React.FC = () => {
  
  const { t } = useTranslation();

 
  const whatToDoList = t('tips:lists.whatToDo.items', { returnObjects: true }) as string[];
  const whatToBringList = t('tips:lists.whatToBring.items', { returnObjects: true }) as string[];

  
  const safeWhatToDo = Array.isArray(whatToDoList) ? whatToDoList : [];
  const safeWhatToBring = Array.isArray(whatToBringList) ? whatToBringList : [];

  return (
    <div className="tips-page-container">
      
      {/* --- 1. Hero Section --- */}
      <header 
        className="tips-hero"
        style={{ backgroundImage: `url(${tipsHero})` }}
      >
        <div className="hero-overlay"></div>
        <h1 className="hero-title">
          <Trans i18nKey="tips:title" />
        </h1>
      </header>

      {/* --- 2. Sección "Tips" (Fondo Negro) --- */}
      <section className="tip-section dark">
        <div className="tip-content">
          <h2 className="tip-title-main">
            <Trans i18nKey="tips:intro.title" />
          </h2>
          <p className="tip-description">
            <Trans 
              i18nKey="tips:intro.description"
              components={{ br: <br/>, strong: <strong /> }}
            />
          </p>
        </div>
      </section>
      
      {/* --- 3. Sección "Pro Tip" (Fondo Blanco) --- */}
      <section className="tip-section light">
        <div className="tip-content">
          <h2 className="tip-title-main">
            <Trans i18nKey="tips:proTip.title" />
          </h2>
          <p className="tip-description">
             <Trans 
              i18nKey="tips:proTip.description"
              components={{ br: <br/>, strong: <strong /> }}
            />
          </p>
        </div>
      </section>

      {/* --- 4. Línea Divisora --- */}
      <div className="linea-global"></div>

      {/* --- 5. Sección "Qué Hacer / Qué Traer" --- */}
      <section className="dos-donts-section">
        <div className="dos-donts-grid">
          
          {/* Columna: Qué Hacer */}
          <div className="dos-donts-column">
            <h3>
              <Trans i18nKey="tips:lists.whatToDo.title" />
            </h3>
            <ul>
              {safeWhatToDo.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          
          {/* Columna: Qué Traer */}
          <div className="dos-donts-column">
             <h3>
              <Trans i18nKey="tips:lists.whatToBring.title" />
            </h3>
            <ul>
              {safeWhatToBring.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

        </div>
      </section>
    </div>
  );
};

export default TipsPage;